var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4558 6.07572C10.9591 6.06377 10.4703 5.95012 10.0193 5.74179C9.56832 5.53346 9.16486 5.23487 8.83383 4.86448C9.01152 5.62045 8.90831 6.41523 8.54344 7.10075C8.17857 7.78626 7.57692 8.31575 6.8506 8.59055C6.12427 8.86535 5.32282 8.86673 4.59555 8.59442C3.86829 8.32211 3.26483 7.79469 2.89761 7.11043C2.53039 6.42617 2.42446 5.63174 2.59956 4.87517C2.77465 4.11859 3.21883 3.45148 3.84932 2.99812C4.47982 2.54476 5.25364 2.33608 6.02659 2.41097C6.79954 2.48585 7.51891 2.83919 8.05065 3.40514C7.83578 2.62561 7.88888 1.7965 8.20145 1.05075C7.33051 0.630125 6.36707 0.437388 5.40133 0.490588C4.4356 0.543787 3.49916 0.841184 2.67968 1.35493C1.86021 1.86868 1.18451 2.58198 0.715845 3.42805C0.247179 4.27411 0.000877416 5.22527 0 6.19247C0 8.46416 1.27448 10.3662 2.20846 11.7525L2.37871 12.0055C3.30796 13.3523 4.30482 14.6511 5.36548 15.897L5.73518 16.33L6.10488 15.897C7.1654 14.651 8.16226 13.3522 9.09164 12.0055L9.2619 11.7477C10.191 10.3613 11.4655 8.46416 11.4655 6.19247C11.4606 6.15355 11.4558 6.11464 11.4558 6.07572Z",
    fill: "#D4307D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.567 4.86444C12.9103 4.86444 13.9992 3.7755 13.9992 2.43222C13.9992 1.08894 12.9103 0 11.567 0C10.2237 0 9.13477 1.08894 9.13477 2.43222C9.13477 3.7755 10.2237 4.86444 11.567 4.86444Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapNew);
export default __webpack_public_path__ + "static/media/map-new.2452acfb.svg";
export { ForwardRef as ReactComponent };